<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <div class="reduced-fit">
                <div class="main-content-header">
                    <h1>Maestro de Credenciales</h1>
                </div>
                <LoadingContent v-if="isLoading" />
                <div class="row w-65">
                    <div class="col-lg-12 ">
                        <div class="card mb-30" >
                            <div class="card-content" >
                                <div class="card-body">
                                    <div class="card-header" >
                                        <h5 class="card-title">{{ titulo }}</h5>
                                    </div>
                                    <div class="row">
                                        <div class="col-10">
                                            <form>
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">Num</label>
                                                    <div class="col-5"> 
                                                        <input ref="numid" type="number" maxlength="3" class="form-control form-control-sm" required v-model="credencial.numid" />													
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">Nombre</label>
                                                    <div class="col-5"> 
                                                        <input ref="nombre" type="text" maxlength="30" class="form-control form-control-sm"  v-model="credencial.nombre" />													
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-4 ps-5 offset-2 form-check">
                                                        <input class="form-check-input" @change="revisaAlertas()"  v-model="credencial.alerta"  type="checkbox" id="alerta">
                                                        <label class="form-check-label" for="alerta">Incluir en Alertas</label>
                                                    </div>
                                                </div>
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">Días Antes</label>
                                                    <div class="col-5"> 
                                                        <input ref="diasantes" type="number" class="form-control form-control-sm" :disabled="diasantes_disabled" v-model="credencial.diasantes" />													
                                                    </div>
                                                </div>	
                                            </form>
                                        </div>
                                        <div class="col-2">
                                            <ul class="d-block p-1 list-unstyled controls-form">
                                                <li><button @click="setCredenciales()" class="btn btn-sm btn-success btn-block">Aceptar</button></li>
                                                <li><router-link to="/credenciales" class="btn btn-sm btn-danger btn-block">Salir</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import handleForm from '@/mixins/handleForm';
import LoadingContent from '@/components/LoadingSpinner.vue'
import handleGlobals from '@/mixins/handleGlobals'
import SideBar from '@/components/SideBarNav.vue';
import TopBar from '@/components/TopBarNav.vue';
export default {
    components:{SideBar, TopBar,LoadingContent },
    mixins:[handleForm,handleGlobals],
    data(){
        return{
            id: this.$route.params.credencial,
            modo: (this.$route.params.credencial > 0 ? 'Modificando' : 'Creacion'), 
            credencial:{},
            titulo: 'Agregando una Credencial',
            diasantes_disabled:false
        }
    },
    mounted(){
        this.llenaForma();
    },
    methods:{
        async llenaForma(){
            await this.getCredenciales();
            if(this.$route.params.contenido > 0 ) {
                this.titulo = 'Cambiando una Credencial'
                this.revisaAlertas()
            }
        },
        getCredenciales(){
            let req = []
            this.isLoading = true
             fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({ accion: "inicializar", modo:this.modo, archivo: "Credenciales", id: this.id })
            }).then((response)=>{
                if(response.ok){
                    return response.json()
                }   
            }).then((data)=>{
                this.credencial = data['res']
                req = data['req']
            }).finally(()=>{
                this.setRequired(req)
                this.isLoading = false
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        setCredenciales(){
            this.isLoading = true
            fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({  accion: 'validar', archivo: "Credenciales", modo:this.modo, record: this.credencial }) 
            }).then((response)=>{
                if(response.ok){
                    return response.json();
                }   
            }).then((data)=>{
                if(data['res'] == 'error'){
                    this.showNotification = true
                    this.notificationTitle =  'Error'
                    this.notificationText = data['msg']
                    this.notificationRef = 'numid'
                }else{
                    this.isLoading = false
                    this.$router.push('/credenciales')
                }
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        afterClose(){
            this.$refs[this.notificationRef].focus()
        },
        revisaAlertas(){
            if(this.credencial.alerta == true){
                this.diasantes_disabled = false
                if(this.credencial.diasantes == 0){
                    this.credencial.diasantes = 15
                }
            }else{
                this.credencial.diasantes = 0
                this.diasantes_disabled = true
            }
        }
     
    }
}
</script>